var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{attrs:{"color":_vm.color,"class-list":_vm.classList,"variant":_vm.variant},on:{"click":_vm.create}},[_vm._t("default",function(){return [_c('span',{staticClass:"block sm:hidden"},[_vm._v(_vm._s(_vm.title))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }